import React from "react";
import WorkOrderCounts from "../child/WorkOrderCounts";
import WorkOrderCompletionByMonth from "../child/WorkOrderCompletionByMonth";
import WorkOrderPriorityChart from "../child/WorkOrderPriorityChart";
import WorkOrderStatusChart from "../child/WorkOrderStatusChart";
import WorkOrderAssetClassChart from "../child/WorkOrderAssetClassChart";
import WorkOrderBreakdownChart from "../child/WorkOrderBreakdownChart";
import WorkOrderMaintenanceIntensity from "../child/WorkOrderMaintenanceIntensity";

const WorkOrdersDashboardLayer = () => {
  return (
    <div className='row gy-4 p-24'>
      <WorkOrderCounts />
      <WorkOrderCompletionByMonth />
      <WorkOrderMaintenanceIntensity />
      <WorkOrderPriorityChart />
      <WorkOrderStatusChart />
      <WorkOrderBreakdownChart />
      <WorkOrderAssetClassChart />
    </div>
  );
};

export default WorkOrdersDashboardLayer;
